/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */
/* eslint-disable import/no-unresolved, import/default */

import providerFieldsetTemplate from './provider-fieldset.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

/*@ngInject*/
export default function ProviderDirective($compile, $templateCache, $translate, types, toast, providerSubscriptionService) {
    var linker = function (scope, element) {
        var template = $templateCache.get(providerFieldsetTemplate);
        element.html(template);
        scope.types = types;

        scope.onProviderIdCopied = function() {
            toast.showSuccess($translate.instant('provider.id-copied-message'), 750, angular.element(element).closest(".toast-parent"), 'bottom left');
        };

        scope.$watch('provider.providerSubscriptionId', (newVal, prevVal) => {
            if (!angular.equals(newVal, prevVal)) {
                if (newVal) {
                    providerSubscriptionService.getProviderSubscription(scope.provider.providerSubscriptionId.id).then(
                        (providerSubscription) => {
                            scope.providerSubscription = providerSubscription;
                        }
                    );
                } else {
                    scope.providerSubscription = null;
                }
            }
        });

        scope.$watch('isEdit', (newVal, prevVal) => {
            if (newVal && !angular.equals(newVal, prevVal)) {
                scope.selectedTab = 0;
            }
        });

        $compile(element.contents())(scope);
    }
    return {
        restrict: "E",
        link: linker,
        scope: {
            provider: '=',
            isEdit: '=',
            theForm: '='
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/provider/provider.directive.js